export default __webpack_public_path__ + "static/media/flg_in.30502647.svg";